import { useTranslation } from 'react-i18next';

import * as S from '@/components/common/Banner/SubBanner/style';

interface SubBannerProps {
	/** i18n 키 */
	title: string;
	/** i18n 키 */
	subTitle: string;
	img: string;
	variant?: 'hero' | 'compact';
}

const SubBanner = ({ title, subTitle, img, variant = 'hero' }: SubBannerProps) => {
	const { t } = useTranslation();

	return (
		<S.SubBannerContainer bgImg={img} $variant={variant}>
			<S.TextBoxWrapper $variant={variant}>
				<p className="sub_title">{t(subTitle)}</p>
				<h1 className="title">{t(title)}</h1>
			</S.TextBoxWrapper>
		</S.SubBannerContainer>
	);
};

export default SubBanner;
